import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function getCarregamentoInfoIniciais(tp_id, pInicial, pFinal) {
  try {
    const { id: user_id } = getUsuarioInfo()

    const response = await authHttp().get(
      routes.urlGetEntregasParaCarregamento(tp_id, pInicial, pFinal, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPorcentagemConferidaEntregasParaCarregamento(tp_id, deliveryStepIds) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(
      routes.urlGetPorcentagemConferidaEntregasParaCarregamento(tp_id, user_id),
      { delivery_step_ids: deliveryStepIds },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCarregamento(tp_id, carregamentos) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(
      routes.urlPostCarregamentoVeiculo(tp_id, user_id),
      carregamentos,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function importarRoteiroEntrega(tp_id, info) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(
      routes.urlPostImportacaoExcelRoteiroEntrega(tp_id, user_id),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function carregarPelasPlacasPrevistas(tp_id, dataPrevista, periodo) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const data_prevista_entrega = parseToMysqlFormat(dataPrevista)
    const pInicial = parseToMysqlFormat(periodo.dataInicial)
    const pFinal = parseToMysqlFormat(periodo.dataFinal)
    return await authHttp().post(routes.urlPostCarregarPelaPlacaPrevista(), {
      tp_id,
      user_id,
      data_prevista_entrega,
      pInicial,
      pFinal,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}
